import React, { PropTypes } from 'react';
import idx from 'idx';
import ImageNameGrid from 'common/components/entry_gallery/image_name_grid';
import ImageNameList from 'common/components/entry_gallery/image_name_list';
import NameDense from 'common/components/entry_gallery/name_dense';

const MAP = {
  image: {
    grid: ImageNameGrid,
    list: ImageNameList
  },
  name: {
    list: ImageNameList,
    dense: NameDense
  }
};

const EntryGallery = (props) => {
  const { entryType, viewType, items } = props;

  if (!items || items.length === 0) {
    return (
      <div className="empty-state no-results">
        <div className="empty-state-content">
          <h3>There are no entries yet.</h3>
        </div>
      </div>
    );
  }

  const Component = idx(MAP, _ => _[entryType][viewType]);

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
}

EntryGallery.propTypes = {
  items: PropTypes.array,
  entryType: PropTypes.string,
  viewType: PropTypes.string,
};

export default EntryGallery;



// WEBPACK FOOTER //
// ./common/components/entry_gallery/index.jsx